export default __webpack_public_path__ + "static/media/oe-5-rMIN.5ce93779.jpg";